import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProofStrip = () => {
  const { language } = useLanguage();
  const sl = language === 'sl';

  const stats = sl ? [
    { value: '20+', label: 'let izkušenj, od leta 2003', desc: 'Zaupanja vredna ekipa računovodskih strokovnjakov' },
    { value: '500+', label: 'strank', desc: 'Podjetja in podjetniki nam zaupajo' },
    { value: '48 h', label: 'do fiksne pisne ponudbe', desc: 'Hitra in transparentna komunikacija' },
    { value: '7–14', label: 'dni do registriranega podjetja', desc: 'Hitro in učinkovito odprtje podjetja' },
  ] : [
    { value: '20+', label: 'years in business, since 2003', desc: 'Trusted team of accounting professionals' },
    { value: '500+', label: 'companies served', desc: 'Businesses and entrepreneurs trust us' },
    { value: '48 h', label: 'to a fixed written quote', desc: 'Fast and transparent communication' },
    { value: '7–14', label: 'days to a registered company', desc: 'Quick and efficient company formation' },
  ];

  return (
    <section className="bg-[#15191D] text-[#F4EFE6]" data-testid="proof-strip" aria-label={sl ? 'Naše reference' : 'Our credentials'}>
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] py-9 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <article key={stat.label} className="flex flex-col gap-1 border-l border-[#343A41] pl-6">
            <span className="font-serif text-[40px] lg:text-[48px] text-[#C9A462]" aria-label={stat.value}>{stat.value}</span>
            <span className="text-[14px] text-[#B9B3A7] font-medium">{stat.label}</span>
            <span className="text-[12px] text-[#7E786D] hidden lg:block">{stat.desc}</span>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ProofStrip;
